// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcQ507{display:flex;box-sizing:border-box;position:relative;flex-direction:column;flex-grow:1;font:"font({theme: 'Body-M'})";color:"color(--defaultColor)";max-width:1000px;margin:0 auto}.lcQ507.QVCCrb{padding:25px 30px}.lcQ507.R_mV4E{padding:0 20px}.M5E6T_{padding-bottom:35px}.M5E6T_.PPRTHq{border-bottom:"unit(--titleDividerWidth, px)" solid "opacity(withoutOpacity(color(--titleDividerColor)), 0.2)"}.M5E6T_>.PVh_2v{margin-bottom:13px;font:"font(--titleFont)";color:"color(--titleColor)"}.M5E6T_>.DQxCpB{font:"font(--subtitleFont)";color:"color(--subtitleColor)"}.uiSA8A{display:flex;flex-direction:column;flex-grow:1}.YYJjRf{font:"font({theme: 'Body-M'})";flex-grow:1;text-align:center}.YYJjRf>:nth-child(1){margin-bottom:20px;font:"font(--noItemsMessageFont)";color:"color(--noItemsMessageColor)"}.YYJjRf>:nth-child(2){font:"font(--noItemsInfoFont)";color:"color(--noItemsInfoColor)"}.YYJjRf .eOp_1K{margin:30px}.QVCCrb .YYJjRf{margin:109px 0}.R_mV4E .YYJjRf{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:50px 0}.VChPkm{direction:rtl;text-align:right}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `lcQ507`,
	"desktop": `QVCCrb`,
	"mobile": `R_mV4E`,
	"header": `M5E6T_`,
	"withBorder": `PPRTHq`,
	"title": `PVh_2v`,
	"subtitle": `DQxCpB`,
	"body": `uiSA8A`,
	"emptyView": `YYJjRf`,
	"addPaymentMethodButtonWrapper": `eOp_1K`,
	"rtl": `VChPkm`
};
export default ___CSS_LOADER_EXPORT___;
